import { Activity, ClipboardCheck, FileBadge, Hammer, Layers, Zap } from 'lucide-react';

/**
 * WP3 service categories, keyed by the registry's `categoryKey`, in
 * catalogue order.
 */
export const SERVICE_CATEGORIES = {
  performance: { title: 'Performance',   icon: Activity,       color: '#2D6A35', tint: '#E3EEDD' },
  epc:         { title: 'Certification', icon: FileBadge,      color: '#C2185B', tint: '#F8E1EA' },
  inspection:  { title: 'Inspection',    icon: ClipboardCheck, color: '#B45309', tint: '#FBEBD5' },
  renovation:  { title: 'Renovation',    icon: Hammer,         color: '#1565C0', tint: '#DFEAF8' },
  activation:  { title: 'Activation',    icon: Zap,            color: '#6A1B9A', tint: '#EEE1F5' },
};

export const SERVICE_CATEGORY_ORDER = Object.keys(SERVICE_CATEGORIES);

const FALLBACK_CATEGORY = { title: 'Service', icon: Layers, color: '#5b5f5b', tint: '#ECECEA' };

export const categoryOf = (categoryKey) => SERVICE_CATEGORIES[categoryKey] || FALLBACK_CATEGORY;

/** Catalogue order: by category, then by service code. */
export const sortServices = (services) =>
  [...services].sort((a, b) => {
    const rank = (s) => {
      const index = SERVICE_CATEGORY_ORDER.indexOf(s.categoryKey);
      return index === -1 ? SERVICE_CATEGORY_ORDER.length : index;
    };
    return rank(a) - rank(b) || String(a.code || '').localeCompare(String(b.code || ''), undefined, { numeric: true });
  });
